import React from "react";
import { UserRound, Phone, X } from "lucide-react";

export default function LinkedCustomerBanner({ linked, linkedVehicle, onPick, onUnlink }) {
  if (!linked) return null;
  return (
    <div className="rounded-2xl border border-amber-500/30 bg-amber-500/5 p-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="linked-customer-banner">
      <div className="w-10 h-10 rounded-xl bg-amber-400/15 grid place-items-center shrink-0"><UserRound className="w-5 h-5 text-amber-300" /></div>
      <div className="min-w-0 flex-1">
        <div className="font-heading font-bold truncate">{linked.name} <span className="text-slate-400 font-mono-num text-sm font-normal ml-1"><Phone className="w-3 h-3 inline mr-1" />{linked.phone}</span></div>
        <div className="flex flex-wrap gap-1.5 mt-1.5">
          {linked.vehicles.map((v) => (
            <button key={v.id} data-on={linkedVehicle?.id === v.id} onClick={() => onPick(v)} data-testid={`linked-vehicle-${v.id}`}
              className="text-xs rounded-lg border border-slate-700 bg-slate-900/60 px-2.5 py-1 text-slate-300 data-[on=true]:border-amber-400 data-[on=true]:bg-amber-400/15 data-[on=true]:text-amber-200 transition-colors">
              <span className="font-mono-num font-bold tracking-wider">{v.plate}</span>{v.make_model ? ` · ${v.make_model}` : ""}{v.paint_code ? <span className="text-violet-300"> · {v.paint_code}</span> : ""}
            </button>
          ))}
        </div>
      </div>
      <button onClick={onUnlink} data-testid="unlink-customer-btn" className="text-xs text-slate-400 hover:text-slate-200 flex items-center gap-1 shrink-0"><X className="w-3.5 h-3.5" /> Walk-in</button>
    </div>
  );
}
